<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <div
      v-if="showAlreadySubmitedPopup"
      ref="popup"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      class="rfp-rr-already-submited-001-or review-popup full-review-active"
      data-popup="review-popup"
      style="display: block"
    >
      <div
        role="button"
        :aria-label="modalCloseButtonAccessibleLabel"
        tabindex="0"
        class="rfp-rr-already-submited-002-or review-popup-close"
        @keydown.space.prevent
        @keyup.space="closePopup"
        @keydown.enter="closePopup"
        @click="closePopup"
      >
        {{ popupClose }}
      </div>
      <div id="success-message" class="rfp-rr-already-submited-003-or popup-inner">
        <div
          class="rfp-rr-already-submited-004-or message-icon success"
          :class="{ 'image--display': alreadySubmitedIcon === '' }"
        >
          <img
            class="rfp-rr-already-submited-005-or"
            :src="alreadySubmitedIcon"
            :style="{ width: '100%' }"
            :alt="alreadySubmitedIconAltText"
          />
        </div>
        <div class="rfp-rr-already-submited-006-or message" v-html="alreadySubmitedText"></div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { trapFocus } from '../../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-ratings-already-submited',
  props: {
    alreadySubmitedIcon: {
      type: String,
      required: true,
    },
    alreadySubmitedText: {
      type: String,
      required: true,
    },
    alreadySubmitedIconAltText: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
  },
  data() {
    return {
      showAlreadySubmitedPopup: false,
      activeSlider: false,
      deactivateFocusTrap: null,
    };
  },
  watch: {
    async showAlreadySubmitedPopup(newVal) {
      if (newVal) {
        await this.$nextTick();
        this.deactivateFocusTrap = trapFocus(this.$refs.popup);
      } else {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('review-already-submitted', () => {
      this.showAlreadySubmitedPopup = true;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.toggle('popup_scroll');
      eventBus.emit('ScrollFalse');
      document.body.classList.add('rare-custom-body-class');
      this.activeSlider = true;
    });
  },
  mounted() {
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.showAlreadySubmitedPopup && event.key === 'Escape') {
        this.closePopup();
      }
    },
    closePopup() {
      this.showAlreadySubmitedPopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.remove('popup_scroll');
      document.body.classList.remove('rare-custom-body-class');
      this.activeSlider = false;
      eventBus.emit('ScrollTrue');
    },
  },
};
</script>
